import { Component, h } from 'preact'

import Header from '../header'
import Panel from '../panel'
import RadioInputGroup from '../ui-components/RadioInputGroup'
import DefaultHeader, {DefaultHeaderData} from './defaultHeader'
import SSIHeader, {SSIHeaderData} from './SSIHeader'
import CustomHeader, {CustomHeaderData} from './CustomHeader'
import {getCommunityHeaderConfig, updateCommunityHeaderConfig, CommunityHeaderConfig} from '../../utils/api'
import AlertComponent from '../ui-components/AlertComponent'

interface Props {}

interface State {
  selectedOption: number,
  defaultHeader: DefaultHeaderData,
  ssiHeader: SSIHeaderData,
  customHeader: CustomHeaderData,
  error?: boolean,
  success?: boolean,
  isLoading?: boolean
}

const options = [
  <div>
    <strong>Default</strong>
    <div>Use default header with configurations</div>
  </div>,
  <div>
    <strong>Server Side Include (SSI) configuration</strong>
    <div>Include external HTML header via URL</div>
  </div>,
  <div>
    <strong>Custom code only</strong>
    <div>Add header via custom HTML</div>
  </div>
]

class CommunityHeader extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      selectedOption: 0,
      defaultHeader: {
        logoUrl: '',
        label: '',
        labelMobile: '',
        url: '',
        backgroundColor: '#000',
        linkColor: '#fff'
      },
      ssiHeader: {
        url: ''
      },
      customHeader: {
        html: ''
      }
    }
  }

  async componentDidMount() {
    this.setStateFromBackgend(await getCommunityHeaderConfig())
  }

  setStateFromBackgend(data: CommunityHeaderConfig) {
    const type = ['default', 'ssi', 'custom']
    this.setState({
      selectedOption: type.indexOf(data.type),
      ssiHeader: data.ssiHeader,
      customHeader: data.customHeader,
      defaultHeader: data.defaultHeader,
    })
  }

  async save () {
    this.setState({ error: false, success: false, isLoading: true })
    let type: 'default' | 'ssi' | 'custom' = 'default'
    if (this.state.selectedOption === 1) type = 'ssi'
    if (this.state.selectedOption === 2) type = 'custom'
    let updated
    try {
      updated = await updateCommunityHeaderConfig({
        type: type,
        ssiHeader: this.state.ssiHeader,
        customHeader: this.state.customHeader,
        defaultHeader: this.state.defaultHeader
      })
    } catch (err) {
      this.setState({ error: true, isLoading: false })
      return
    }
    this.setStateFromBackgend(updated)
    this.setState({ success: true, isLoading: false })
  }

  render (_: Props, { selectedOption, defaultHeader, ssiHeader, customHeader, error, success, isLoading } : State) {
    const subComponents = [
      <DefaultHeader {...defaultHeader} onChange={(newData: DefaultHeaderData) => this.setState({ defaultHeader: { ...this.state.defaultHeader, ...newData } })} />,
      <SSIHeader {...ssiHeader} onChange={(newData: SSIHeaderData) => this.setState({ ssiHeader: { ...this.state.ssiHeader, ...newData } })}/>,
      <CustomHeader {...customHeader} onChange={(newData: CustomHeaderData) => this.setState({ customHeader: { ...this.state.customHeader, ...newData } })} />
    ]

    return (
      <div className='community-header'>
        <Header
          isLoading={isLoading}
          title='Header'
          saveCallback={() => this.save()}
        />

        {error && <AlertComponent
          messageType='error'
          message={'Could not save configuration'}
          renderHTML
          isVisibleFor={3000}
        />}

        {success && <AlertComponent
          messageType='success'
          isVisibleFor={3000}
        />}

        <Panel title='Header type'>
          <div className='community-header_radio-buttons'>
            <RadioInputGroup
              title=''
              options={options}
              onChange={(_: unknown, idx: number) => this.setState({ selectedOption: idx })}
              value={options[selectedOption]}
            />
          </div>
          <div className='community-header_sub-component'>
            {subComponents[selectedOption]}
          </div>
        </Panel>
      </div>
    )
  }
}

export default CommunityHeader
